import { Box, styled } from '@mui/material';

export const BottomMenuHeight = '60vh';

export const NavigatorWrapper = styled(Box)<{ ismenuuserbox: string }>(
  ({ theme, ismenuuserbox }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    backgroundColor: `${
      ismenuuserbox ? theme.inferiorMenu.userMenuBg : 'inherit'
    }`,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    height: '100%'
  })
);

export const NavigatorScreensContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  minHeight: BottomMenuHeight,
  maxHeight: BottomMenuHeight,
  marginTop: theme.spacing(2.7)
}));
